import { useTranslation } from 'react-i18next';
import { ProgressGradient } from '@/components/ui/progress-gradient';
import { formatNumberToVolume } from '@/lib/format';

type LotSizingFillRateContentProps = {
  currentVolume: number;
  totalVolume: number;
  fillRate: number;
  totalContainers: number;
};

export function LotSizingFillRateContent({
  currentVolume,
  totalVolume,
  fillRate,
  totalContainers,
}: LotSizingFillRateContentProps) {
  const { t } = useTranslation('lotSizing');

  return (
    <>
      <div className='flex flex-row items-center justify-center gap-18'>
        <div className='font-bold text-4xl'>{fillRate.toFixed(0)}%</div>
        <div className='font-medium text-2xl'>
          {formatNumberToVolume(currentVolume)} /{' '}
          {formatNumberToVolume(totalVolume)}
        </div>
      </div>
      <ProgressGradient className='mt-4 h-4' value={fillRate} />
      <div className='mt-4 text-muted-foreground text-sm'>
        {t('totalContainersLabel')} :{' '}
        <span className='font-medium'>{totalContainers}</span>
      </div>
    </>
  );
}
